import React from "react";
import { X } from "lucide-react"; // Optional: icon package, install with `npm i lucide-react`
import { useNavigate } from "react-router-dom";

export default function PaymentModeModal({
  isOpen,
  onClose,
  onPay,
  setPaymentMode,
  isLoggingIn,
  paymentMode,
  paymentItem,
  paymenttype,
  venderid,
}) {
  const navigate = useNavigate();
  if (!isOpen) return null;

  console.log(paymentItem, venderid, "jkdhguthrbj");

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg w-full max-w-md shadow-lg overflow-hidden">
        {/* Header */}
        <div className="bg-[#0c4079] px-5 py-4 flex justify-between items-center">
          <h2 className="text-white font-semibold text-lg">
            Select Payment Mode
          </h2>
          <button onClick={onClose}>
            <X className="text-white w-5 h-5" />
          </button>
        </div>

        {/* Options */}
        <div className="px-5 py-6 space-y-3">
          {paymenttype !== "Order" ? (
            <button
              onClick={() => setPaymentMode("CASH")}
              className={`w-full px-4 py-3 rounded-md flex justify-between items-center text-sm
              ${
                paymentMode === "CASH"
                  ? "border-2 border-[#0c407980] bg-[#eaf3fc] text-[#0c4079]"
                  : "border-2 border-gray-300 bg-[#f5faff] text-[#0c4079]"
              }`}
            >
              Cash
              <span className="text-[#0c4079]">&gt;</span>
            </button>
          ) : (
            ""
          )}
          <button
            onClick={() => setPaymentMode("CC")}
            className={`w-full px-4 py-3 rounded-md flex justify-between items-center text-sm
              ${
                paymentMode === "CC"
                  ? "border-2 border-[#0c407980] bg-[#eaf3fc] text-[#0c4079]"
                  : "border-2 border-gray-300 bg-[#f5faff] text-[#0c4079]"
              }`}
          >
            Debit/Credit Cards/UPI & Others
            <span className="text-[#0c4079]">&gt;</span>
          </button>
        </div>

        {/* Pay Button */}
        <div className="px-5 pb-6">
          <button
            onClick={() => {
              onPay(paymentItem);
              if (paymentMode === "CC") {
                navigate("/Paymentpage", {
                  state: {
                    appointmentId: paymentItem,
                    paymenttype: paymenttype, // Pass the payment
                    venderid: venderid,
                    payMode: paymentMode,
                  },
                });
              } else {
                onPay(paymentItem); // for CASH
                navigate("/Paymentpage", {
                  state: {
                    appointmentId: paymentItem,
                    paymenttype: paymenttype, // Pass the payment
                    venderid: venderid,
                    payMode: paymentMode,
                  },
                });
              }
            }}
            className="w-full bg-[#3cba84] hover:bg-[#35a874] text-white py-2 rounded-md font-medium"
          >
            {isLoggingIn ? "Loading.." : "Pay"}
          </button>
        </div>
      </div>
    </div>
  );
}
